module.exports = __webpack_public_path__ + "28f82cff79d3ede78357eae05612288d.png";